<div class="mb-4 rounded rounded-s bg-neutral-100 p-4 font-base text-sm text-neutral-700">
  {{ 'payment.on-site-picker' | translate }}
</div>

<app-payment-panel-stripe-generic
  [type]="paymentMethodHandles.Onsite"
  [payButtonText]="'payment.pay-with-credit-card' | translate"
></app-payment-panel-stripe-generic>
